<div class="row">
  <div class="col-md-12 col-xs-12 vh-100">
    <ag-grid-angular
      class="ag-theme-alpine"
      [gridOptions]="gridOptions"
      (gridReady)="gridSetting($event)"
      [columnDefs]="columnDefs"
      [rowData]="loadings"
      [domLayout]="'autoHeight'"
      [pagination]="true"
      [paginationPageSize]="10"
      [paginationPageSizeSelector]="[10,20,30]"
      [enableCellTextSelection]="true">
    </ag-grid-angular>
    <div class="modal fade" id="loadingModal" tabindex="-1"
      aria-labelledby="loadingModalLabel">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"
            id="loadingModalLabel">{{truckReport?.truckNumber}}</h5>
          </div>
          <div class="modal-body">
            @for (loadings of truckReport?.groupedLoadings; track $index) {
              <div
                class="card">
                <table
                  class="table table-sm table-striped table-bordered text-center">
                  <thead>
                    <tr>
                      <td>نام شرکت</td>
                      <td>تعداد</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{organisationNameFormatter(loadings.companyId)}}</td>
                      <td>{{loadings.count}}</td>
                    </tr>
                  </tbody>
                </table>
                <div>
                  <table
                    class="table table-sm table-striped table-bordered text-center">
                    <thead>
                      <tr>
                        <td>تاریخ</td>
                        <td>مبدا</td>
                        <td>نام راننده</td>
                        <td>مقصد</td>
                        <td>وزن</td>
                      </tr>
                    </thead>
                    <tbody>
                      @for (loading of loadings.loadings; track $index) {
                        <tr>
                          <td>{{loading.loadTimestamp | persianDate}}</td>
                          <td>{{organisationNameFormatter(loading.sourceOrganisationId)}}</td>
                          <td>{{loading.driverName}}</td>
                          <td>{{organisationNameFormatter(loading.destinationOrganisationId)}}</td>
                          <td>{{loading.loadingWeight | number}}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
